var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "add-work-email" },
    [
      _c(
        "div",
        { staticClass: "content" },
        [
          _vm._m(0),
          _c("div", { staticClass: "text" }, [_vm._v("基本信息")]),
          _c(
            "div",
            { staticClass: "forms" },
            [
              _c(
                "el-form",
                {
                  ref: "form",
                  staticClass: "form",
                  attrs: {
                    inline: true,
                    model: _vm.form,
                    rules: _vm.rules,
                    size: "small",
                    "label-width": "96px",
                    autocomplete: "off",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "标题:", prop: "title" } },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: "请输入",
                          maxlength: "50",
                          clearable: "",
                          disabled: _vm.isReadonly,
                          "show-word-limit": "",
                        },
                        model: {
                          value: _vm.form.title,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "title", $$v)
                          },
                          expression: "form.title",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "add-category",
                      attrs: { label: "选择分类:", prop: "category" },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "category-container" },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: {
                                width: "100%",
                                "margin-right": "16px",
                              },
                              attrs: {
                                placeholder: "请选择",
                                disabled: _vm.isReadonly,
                              },
                              model: {
                                value: _vm.form.category,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "category", $$v)
                                },
                                expression: "form.category",
                              },
                            },
                            _vm._l(_vm.categoryList, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: {
                                  label: item.categoryName,
                                  value: item.id,
                                },
                              })
                            }),
                            1
                          ),
                          _vm.btnPermission.createCategory
                            ? _c(
                                "div",
                                {
                                  staticClass: "add-category-btn",
                                  staticStyle: { cursor: "pointer" },
                                  on: { click: _vm.showAddCategoryDialog },
                                },
                                [
                                  _c("img", {
                                    staticStyle: {
                                      width: "10px",
                                      height: "10px",
                                      "margin-right": "4px",
                                    },
                                    attrs: {
                                      src: require("@/assets/img/announcement/add.png"),
                                    },
                                  }),
                                  _c("span", [_vm._v("新建分类")]),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]
                  ),
                  _c(
                    "el-form-item",
                    { staticClass: "t-label", attrs: { label: "作者:" } },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: "请输入",
                          clearable: "",
                          maxlength: "256",
                          rows: "3",
                          "show-word-limit": "",
                          disabled: _vm.isReadonly,
                        },
                        model: {
                          value: _vm.form.author,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "author", $$v)
                          },
                          expression: "form.author",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "label-star",
                      attrs: { label: "接收人员:", prop: "receivers" },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "category-container" },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "select-u",
                              staticStyle: {
                                "margin-right": "16px",
                                width: "100%",
                              },
                              attrs: {
                                placeholder: "请选择接收人员",
                                "collapse-tags": "",
                                size: "medium",
                                multiple: "",
                                "popper-class": "hidden",
                                disabled: _vm.isReadonly,
                              },
                              nativeOn: {
                                click: function ($event) {
                                  return _vm.openUserPicker.apply(
                                    null,
                                    arguments
                                  )
                                },
                              },
                              model: {
                                value: _vm.form.receivers,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "receivers", $$v)
                                },
                                expression: "form.receivers",
                              },
                            },
                            _vm._l(_vm.form.receivers, function (user, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: { label: user.name, value: user },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "label-star",
                      staticStyle: { display: "flex" },
                      attrs: { label: "正文:", prop: "content" },
                      scopedSlots: _vm._u([
                        {
                          key: "label",
                          fn: function () {
                            return [
                              _c("div", { staticStyle: { width: "88px" } }, [
                                _vm._v("正文:"),
                              ]),
                            ]
                          },
                          proxy: true,
                        },
                      ]),
                    },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            border: "1px solid #ccc",
                            width: "104vh",
                            position: "relative",
                          },
                        },
                        [
                          _vm.editorReady && !_vm.isReadonly
                            ? [
                                _c("Toolbar", {
                                  staticStyle: {
                                    "border-bottom": "1px solid #ccc",
                                  },
                                  attrs: {
                                    editor: _vm.editor,
                                    defaultConfig: _vm.toolbarConfig,
                                    mode: _vm.mode,
                                  },
                                }),
                              ]
                            : _vm._e(),
                          _c("Editor", {
                            staticStyle: {
                              height: "500px",
                              "overflow-y": "hidden",
                            },
                            attrs: {
                              defaultConfig: _vm.editorConfig,
                              mode: _vm.mode,
                            },
                            on: {
                              onChange: _vm.onEditorChange,
                              onCreated: _vm.onCreated,
                            },
                            model: {
                              value: _vm.html,
                              callback: function ($$v) {
                                _vm.html = $$v
                              },
                              expression: "html",
                            },
                          }),
                          _c("div", { staticClass: "word-count" }, [
                            _vm._v(_vm._s(_vm.wordCount) + "/10000"),
                          ]),
                        ],
                        2
                      ),
                    ]
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "label-star",
                      staticStyle: { display: "flex" },
                      attrs: { label: "附件:", prop: "attachmentList" },
                    },
                    [
                      _c(
                        "div",
                        { staticStyle: { width: "100%" } },
                        [
                          _c("attachment-upload", {
                            attrs: { disabled: _vm.isReadonly },
                            model: {
                              value: _vm.form.attachmentList,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "attachmentList", $$v)
                              },
                              expression: "form.attachmentList",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                  _c("div", { staticClass: "line" }),
                  _c("p", [_vm._v("更多信息")]),
                  _c(
                    "div",
                    { staticClass: "more-info" },
                    [
                      _c(
                        "el-row",
                        { attrs: { gutter: 24 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "创建时间：" } },
                                [
                                  _c("div", { staticClass: "con" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.formatDateTime(_vm.form.createdTime)
                                      )
                                    ),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "发起人：" } },
                                [
                                  _c("div", { staticClass: "con" }, [
                                    _vm._v(
                                      _vm._s(_vm.form.createdByName || "-")
                                    ),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "审批状态：" } },
                                [
                                  _c("div", { staticClass: "con" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.getDictName(
                                          _vm.dictionaries
                                            .notice_approval_status,
                                          _vm.form.approvalStatus
                                        )
                                      )
                                    ),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "公告状态：" } },
                                [
                                  _c("div", { staticClass: "con" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.getDictName(
                                          _vm.dictionaries.notice_status,
                                          _vm.form.noticeStatus
                                        )
                                      ) + " "
                                    ),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        { attrs: { gutter: 24 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "更新时间：" } },
                                [
                                  _c("div", { staticClass: "con" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.formatDateTime(_vm.form.updatedTime)
                                      )
                                    ),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "最近更新人：" } },
                                [
                                  _c("div", { staticClass: "con" }, [
                                    _vm._v(
                                      _vm._s(_vm.form.updatedByName || "-")
                                    ),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "发布时间：" } },
                                [
                                  _c("div", { staticClass: "con" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.formatDateTime(_vm.form.publishTime)
                                      )
                                    ),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "发送人数：" } },
                                [
                                  _c("div", { staticClass: "con" }, [
                                    _vm._v(_vm._s(_vm.form.sendCount || "-")),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        { attrs: { gutter: 24 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "已读人数：" } },
                                [
                                  _c("div", { staticClass: "con" }, [
                                    _vm._v(_vm._s(_vm.form.readCount || "-")),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "确认人数：" } },
                                [
                                  _c("div", { staticClass: "con" }, [
                                    _vm._v(
                                      _vm._s(_vm.form.confirmCount || "-")
                                    ),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "未读人数：" } },
                                [
                                  _c("div", { staticClass: "con" }, [
                                    _vm._v(_vm._s(_vm.form.unreadCount || "-")),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "审批详情：" } },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "con" },
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          staticClass: "btn-look",
                                          attrs: {
                                            type: "primary",
                                            plain: "",
                                            size: "mini",
                                            loading: _vm.approvalBtnLoading,
                                            disabled:
                                              !_vm.form.processInstanceId,
                                          },
                                          on: { click: _vm.showApprovalDetail },
                                        },
                                        [_vm._v("查看")]
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "footer",
              class: [_vm.isCollapsed ? "footer-collapsed" : ""],
            },
            [
              _c(
                "el-button",
                { attrs: { type: "info", plain: "" }, on: { click: _vm.back } },
                [_vm._v("返回")]
              ),
              _vm.btnPermission.reset
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary", plain: "" },
                      on: { click: _vm.reset },
                    },
                    [_vm._v("重置")]
                  )
                : _vm._e(),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", plain: "" },
                  on: { click: _vm.preview },
                },
                [_vm._v("预览")]
              ),
              _vm.btnPermission.save && String(_vm.form.noticeStatus) === "3"
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary", loading: _vm.btnSave },
                      on: { click: _vm.save },
                    },
                    [_vm._v("保存草稿")]
                  )
                : _vm._e(),
              _vm.btnPermission.exportRead
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary", plain: "" },
                      on: { click: _vm.exportReadList },
                    },
                    [_vm._v("导出名单")]
                  )
                : _vm._e(),
              _vm.canCancel === true
                ? _c(
                    "el-button",
                    { attrs: { type: "danger" }, on: { click: _vm.cancel } },
                    [_vm._v("撤销")]
                  )
                : _vm._e(),
              _vm.btnPermission.down
                ? _c(
                    "el-button",
                    { attrs: { type: "danger" }, on: { click: _vm.revoke } },
                    [_vm._v("撤回公告")]
                  )
                : _vm._e(),
              _vm.btnPermission.submit
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary", loading: _vm.btnSubmit },
                      on: { click: _vm.submit },
                    },
                    [_vm._v("提交")]
                  )
                : _vm._e(),
              _vm.taskId !== null && _vm.isReadonly
                ? _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        loading: _vm.btnApprovalLoading,
                      },
                      on: { click: _vm.showApprovalDialog },
                    },
                    [_vm._v("审批")]
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "el-dialog",
            {
              staticClass: "add-category-dialog",
              attrs: {
                visible: _vm.addCategoryDialogVisible,
                width: "520px",
                modal: false,
              },
              on: {
                "update:visible": function ($event) {
                  _vm.addCategoryDialogVisible = $event
                },
              },
            },
            [
              _c(
                "el-form",
                {
                  ref: "newCategoryForm",
                  attrs: { model: _vm.newCategoryForm },
                },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: "分类名", prop: "name" },
                      scopedSlots: _vm._u([
                        {
                          key: "label",
                          fn: function () {
                            return [
                              _c(
                                "div",
                                {
                                  staticClass: "dialog-title",
                                  staticStyle: { "text-align": "left" },
                                },
                                [
                                  _vm._v("分类名 "),
                                  _c("br"),
                                  _c("span", [
                                    _vm._v(
                                      "新建分类默认排在最后，可在分类列表中调整显示排序"
                                    ),
                                  ]),
                                ]
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ]),
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: "请输入名称(限10个字符)",
                          maxlength: "10",
                        },
                        model: {
                          value: _vm.newCategoryForm.name,
                          callback: function ($$v) {
                            _vm.$set(_vm.newCategoryForm, "name", $$v)
                          },
                          expression: "newCategoryForm.name",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "span",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function ($event) {
                          _vm.addCategoryDialogVisible = false
                        },
                      },
                    },
                    [_vm._v("取消")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.addCategory },
                    },
                    [_vm._v("确定")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-dialog",
            {
              staticClass: "approval-dialog",
              attrs: {
                "append-to-body": true,
                visible: _vm.approvalDialogVisible,
                width: "500px",
                title: "审批",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.approvalDialogVisible = $event
                },
              },
            },
            [
              _c("div", { staticClass: "apply-title" }, [
                _vm._v("请确认审批结果"),
              ]),
              _c(
                "el-form",
                {
                  ref: "approvalForm",
                  attrs: {
                    model: _vm.approvalForm,
                    rules: _vm.approvalRules,
                    "label-width": "80px",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "审批结果", prop: "type" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.approvalForm.type,
                            callback: function ($$v) {
                              _vm.$set(_vm.approvalForm, "type", $$v)
                            },
                            expression: "approvalForm.type",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: "pass" } }, [
                            _vm._v("通过"),
                          ]),
                          _c("el-radio", { attrs: { label: "reject" } }, [
                            _vm._v("驳回"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "备注", prop: "comment" } },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "textarea",
                          rows: 4,
                          maxlength: "64",
                          "show-word-limit": "",
                        },
                        model: {
                          value: _vm.approvalForm.comment,
                          callback: function ($$v) {
                            _vm.$set(_vm.approvalForm, "comment", $$v)
                          },
                          expression: "approvalForm.comment",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "span",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function ($event) {
                          _vm.approvalDialogVisible = false
                        },
                      },
                    },
                    [_vm._v("取消")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.submitApproval },
                    },
                    [_vm._v("确定")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            [
              _c(
                "el-dialog",
                {
                  staticClass: "preview-dialog",
                  attrs: {
                    "append-to-body": true,
                    visible: _vm.previewDialogVisible,
                    width: "800px",
                    title: "公告预览",
                    modal: true,
                  },
                  on: {
                    "update:visible": function ($event) {
                      _vm.previewDialogVisible = $event
                    },
                  },
                },
                [
                  _c("div", { staticClass: "preview-content" }, [
                    _c("div", { staticClass: "preview-title" }, [
                      _c("span", [
                        _vm._v(_vm._s(_vm.previewData.title || "无标题")),
                      ]),
                    ]),
                    _c("div", { staticClass: "preview-meta" }, [
                      _vm.previewData.categoryName || _vm.previewData.author
                        ? _c("div", { staticClass: "meta-item" }, [
                            _c("span", { staticClass: "meta-value" }, [
                              _vm._v(_vm._s(_vm.previewData.author || "")),
                            ]),
                            _c("span", { staticStyle: { padding: "0 10px" } }, [
                              _vm._v("|"),
                            ]),
                            _c("span", { staticStyle: { color: "#409EFF" } }, [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    "#" +
                                      (_vm.previewData.categoryName || "") +
                                      "#"
                                  ) +
                                  " "
                              ),
                            ]),
                          ])
                        : _vm._e(),
                      _c("div", { staticClass: "meta-item" }, [
                        _c("span", [_vm._v(_vm._s(_vm.currentTime))]),
                      ]),
                    ]),
                    _c("div", { staticClass: "preview-body" }, [
                      _c("div", {
                        staticClass: "preview-html",
                        domProps: {
                          innerHTML: _vm._s(_vm.previewData.content),
                        },
                      }),
                    ]),
                    _vm.previewData.attachmentList &&
                    _vm.previewData.attachmentList.length
                      ? _c(
                          "div",
                          { staticClass: "preview-attachments" },
                          [
                            _c("h3", [_vm._v("附件")]),
                            _c("approval-attachment-list", {
                              attrs: { files: _vm.previewData.attachmentList },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _c("div", { staticClass: "preview-read" }, [
                      _c("span", { staticStyle: { "margin-right": "10px" } }, [
                        _vm._v(_vm._s(_vm.form.readCount || 0) + "人已读"),
                      ]),
                      _c("span", [
                        _vm._v(_vm._s(_vm.form.unreadCount || 0) + "人未读"),
                      ]),
                    ]),
                  ]),
                  _c(
                    "span",
                    {
                      staticClass: "dialog-footer",
                      attrs: { slot: "footer" },
                      slot: "footer",
                    },
                    [
                      _c(
                        "el-button",
                        {
                          on: {
                            click: function ($event) {
                              _vm.previewDialogVisible = false
                            },
                          },
                        },
                        [_vm._v("关闭")]
                      ),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("org-picker", {
        ref: "orgPicker",
        attrs: { title: "接收人员", multiple: true },
        on: { ok: _vm.selectedUser },
      }),
      _c("pop-process", { ref: "popProcess" }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "data-title" }, [
      _c("div", { staticClass: "title-name" }, [_vm._v("编辑公告内容")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }